import React from "react";
import { BurgerMenu } from "./components/BurgerMenu";
import { Features } from "./components/Features";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { useOpenBurgerMenu } from "./components/Hooks/useOpenBurgerMenu";
import { useScrollToTop } from "./components/Hooks/useScrollToTop";
import { MapYandex } from "./components/MapYandex";
import { ReqDocuments } from "./components/ReqDocuments";
import { ScopeOfAccreditation } from "./components/ScopeOfAccreditation";
import { ScrollTop } from "./components/ScrollTop";
import "./styles/App.css";
import "./styles/fonts.css";
import "./styles/responsive.css";

function App() {
  const scrollToTop = useScrollToTop();
  const openBurgerMenu = useOpenBurgerMenu();

  return (
    <div className="App">
      <Header { ...openBurgerMenu } />
      <ReqDocuments />
      <ScopeOfAccreditation />
      <Features />
      <MapYandex />
      {/* <Accreditation /> */}
      <Footer />
      <ScrollTop { ...scrollToTop } />
      <BurgerMenu { ...openBurgerMenu } />
    </div>
  );
}

export default App;
